export default __webpack_public_path__ + "static/media/mobile-tickets.26bd6e2c.svg";